(function () {
  function initialise(root) {
    if (!root || root.dataset.livingProductReady === 'true') return;

    root.dataset.livingProductReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-living-product-card]'));
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-living-product-video]'));
    var ratios = new Map();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 750px)');
    var sectionNear = false;

    if (!cards.length || !videos.length || !('IntersectionObserver' in window)) return;

    function hydrate(video) {
      if (video.dataset.hydrated === 'true' || !video.dataset.src) return;
      video.muted = true;
      video.src = video.dataset.src;
      video.dataset.hydrated = 'true';
    }

    function pauseVideo(video) {
      if (video._livingProductTimer) {
        window.clearTimeout(video._livingProductTimer);
        video._livingProductTimer = null;
      }

      video.pause();
      var card = video.closest('[data-living-product-card]');
      if (card) card.classList.remove('is-playing');
    }

    function playVideo(video, delay) {
      if (reducedMotion.matches || !sectionNear || document.hidden) return;
      if (!video.paused || video._livingProductTimer) return;

      hydrate(video);
      video._livingProductTimer = window.setTimeout(function () {
        video._livingProductTimer = null;
        if (reducedMotion.matches || !sectionNear || document.hidden) return;

        var playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(function () {
            var card = video.closest('[data-living-product-card]');
            if (card) card.classList.remove('is-playing');
          });
        }
      }, delay);
    }

    function reconcilePlayback() {
      if (reducedMotion.matches || !sectionNear || document.hidden) {
        videos.forEach(pauseVideo);
        return;
      }

      if (desktop.matches || cards.length === 1) {
        videos.forEach(function (video, index) {
          var card = video.closest('[data-living-product-card]');
          if ((ratios.get(card) || 0) >= 0.42) {
            playVideo(video, index * 180);
          } else {
            pauseVideo(video);
          }
        });
        return;
      }

      var mostVisibleCard = null;
      var mostVisibleRatio = 0;
      cards.forEach(function (card) {
        var ratio = ratios.get(card) || 0;
        if (ratio > mostVisibleRatio) {
          mostVisibleCard = card;
          mostVisibleRatio = ratio;
        }
      });

      cards.forEach(function (card) {
        var video = card.querySelector('[data-living-product-video]');
        if (card === mostVisibleCard && mostVisibleRatio >= 0.55) {
          playVideo(video, 0);
        } else {
          pauseVideo(video);
        }
      });
    }

    videos.forEach(function (video) {
      video.addEventListener('playing', function () {
        var card = video.closest('[data-living-product-card]');
        if (card && !video.paused) card.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        var card = video.closest('[data-living-product-card]');
        if (card) card.classList.remove('is-playing');
      });
      video.addEventListener('error', function () {
        var card = video.closest('[data-living-product-card]');
        if (card) card.classList.remove('is-playing');
      });
    });

    var sectionObserver = new IntersectionObserver(function (entries) {
      sectionNear = entries.some(function (entry) { return entry.isIntersecting; });
      if (sectionNear && !reducedMotion.matches) videos.forEach(hydrate);
      reconcilePlayback();
    }, { rootMargin: '320px 0px', threshold: 0 });

    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
      reconcilePlayback();
    }, { threshold: [0, 0.25, 0.42, 0.55, 0.7, 0.85, 1] });

    sectionObserver.observe(root);
    cards.forEach(function (card) {
      ratios.set(card, 0);
      cardObserver.observe(card);
    });

    function handleMotionChange() {
      reconcilePlayback();
    }

    function handleVisibilityChange() {
      reconcilePlayback();
    }

    reducedMotion.addEventListener('change', handleMotionChange);
    desktop.addEventListener('change', handleMotionChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    root._livingProductCleanup = function () {
      sectionObserver.disconnect();
      cardObserver.disconnect();
      videos.forEach(pauseVideo);
      reducedMotion.removeEventListener('change', handleMotionChange);
      desktop.removeEventListener('change', handleMotionChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }

  function initialiseAll(scope) {
    var context = scope || document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-living-product-showcase]'), initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-living-product-showcase]');
    Array.prototype.forEach.call(roots, function (root) {
      if (typeof root._livingProductCleanup === 'function') root._livingProductCleanup();
    });
  });
})();
